$(document).ready(function() {

    /****COOKIES SYSTEM****/

    const cookies = getCookie('cookie-consent');

    //if undefined cookie cookie-consent or not accepted, create
    if(typeof cookies === 'undefined' || cookies==='enabled'){

        clearCookies(); //if not accepted yet clear cookies analytics

        /*IF NOT ACCEPTED SHOW BAR */
        $('#cookie-bar-fixed').show();

        //Sets expiration date for cookie
        var expireDate = new Date();
        var date = 3600 * 1000 * 24 * 365;
        expireDate.setTime(expireDate.getTime()+(date));
        expireDate = expireDate.toGMTString();
        var cookieEntry = 'cookie-consent={value}; expires='+expireDate+'; path=/';

        //Retrieves current cookie preference
        var i,cookieValue='',aCookie,aCookies=document.cookie.split('; ');
        for (i=0;i<aCookies.length;i++){
            aCookie = aCookies[i].split('=');
            if(aCookie[0]==='cookie-consent'){
                cookieValue = aCookie[1];
            }
        }

        cookieValue = 'enabled';
        document.cookie = cookieEntry.replace('{value}','enabled');

        //Sets up default cookie preference if not already set
        if(cookieValue==='' && doReturn!=='cookies' && options.autoEnable){
            document.cookie = cookieEntry.replace('{value}','enabled');
        }else if((cookieValue==='accepted' || cookieValue==='declined') && doReturn!=='cookies' && options.renewOnVisit){
            document.cookie = cookieEntry.replace('{value}',cookieValue);
        }
    }

    //save cookies -> calls CookieController(function saveCookies)
    $('.accept-cookies').on('click',function(event) {
        event.preventDefault();

        var analytics = $('#checkbox-analytics').is(":checked") ? 1 : 0;

        if($(this).hasClass('all-cookies')) {
            analytics = true;
        }

        $.ajax({
            type: "POST",
            url: $(this).data('url'),
            data: {analytics: analytics},
            dataType: 'json',
            cache: false,
            global: false, //disable ajaxStart animation
            beforeSend: function() {
                $('#cookie-bar-fixed').hide();
            },
            success: function (data) {
                if (data.status === 0) {
                    //set cookie cookie-consent accepted with analytics(value all) for 1 year, with that we will not show cookie consent bar until cookie ends.
                    document.cookie = cookieEntry.replace('{value}','all');
                    $('.analytics-cookies').html(data.html);
                }else if(data.status === 1){
                    //set cookie cookie-consent accepted for 1 year(no analytics, but we will not show cookie consent bar until cookie ends)
                    document.cookie = cookieEntry.replace('{value}','accepted');
                }else{
                    console.log("error");
                }
            },
            error: function (message) {
                console.log('Error: ' + message);
                response('Error: ' + message);
            }
        });

    });

    /****END COOKIES SYSTEM****/

    $('#bday').myDatePicker();
    $('#birthdate-default').myDatePicker();
    $('.setDatePicker').each( function ( index) {
       $(this).myDatePicker();
    });

    $('.FO_toggleElement').on('click',function(event) {
        event.preventDefault();
        var target = $($(this).data('target'));

        target.slideToggle();
    });

    $('#validate_code').on('click',  function (event) {

        event.preventDefault();

        $('#validate_code_message').html('');
        $('#discount_container').html('');

        var $button = $(this);
        var validate_code_url = $button.data("urlvalidate");
        var total = $('#price').val();
        var promo_code = $('#promo_code').val();
        var content_id = $('#content_id').val();

        $.ajax({
            type: "POST",
            url: validate_code_url,
            cache: false,
            data: {'content_id': content_id, 'total': total, 'promo_code': promo_code  },
            dataType: 'json',
            beforeSend: function() {
                $button.hide();
            },
            success: function (data) {
                if (data.status == 0) {
                    console.log('validate ok');
                    $('#discount_container').html(data.discount + data.new_total );
                } else {

                }
                $('#validate_code_message').html(data.message);

            },
            complete: function() {
                $button.show();
            }
        });

        return false;

    });

    /*$('body').on('click', '#validate_code_cart',  function (event) {

        event.preventDefault();

        var $this = $(this);
        var validate_code_url = $this.data("urlvalidate");
        var promo_code = $('#promo_code').val();

        $(this).find('.fop-error-container').each(function () {
            $(this).removeClass('fop-error-container');
            $(this).find('.fop-error-right').remove();
        });
        var $button = $(this).find('[type=submit]').last();
        $.ajax({
            type: "POST",
            url: validate_code_url,
            cache: false,
            data: {'promo_code': promo_code},
            dataType: 'json',
            beforeSend: function() {
                $button.hide();
                $button.after('<div class="cssload-square"> <div class="cssload-square-part cssload-square-green"></div> <div class="cssload-square-part cssload-square-pink"></div> <div class="cssload-square-blend"></div> </div>');
            },
            success: function (data) {
                $('#summary-container').html(data.view);
                $('#summary-message-code').html(data.message);
            },
            complete: function() {
                $('.cssload-square').remove();
                $button.show();
                $('#summary-message-code').hide().fadeIn();
            }
        });
    });*/

    $('body').on('click', '.add-family-member', function(event) {
        event.preventDefault();

        var findClass = '';
        if ($('#is-client').hasClass('active')) {
            findClass = '#is-client';
        } else {
            findClass = '#new-client';
        }

        var dates = {};
        if($('#babies').length) {
            dates = {'maxDate': 0}
        }

        if($('#pregnancy').length) {
            dates = {'minDate':0}
        }

        $('.family-original').first().clone().removeClass('family-original').removeClass('dnone').appendTo(findClass + ' .family-container').find('.birthdate').myDatePicker(dates);

        $(findClass+' .family-container .family-inputs [name="familyname[]"]').attr('required',"required");
        $(findClass+' .family-container .family-inputs [name="birthdate[]"]').attr('required',"required");
    });

    $('body').on('click', '[href="#is-client"]', function(event) {
        event.preventDefault();
        $('#new-client .family-container .family-inputs [name="familyname[]"]').prop('required',false);
        $('#new-client .family-container .family-inputs [name="birthdate[]"]').prop('required',false);
        $('#is-client .family-container .family-inputs [name="familyname[]"]').attr('required',"required");
        $('#is-client .family-container .family-inputs [name="birthdate[]"]').attr('required',"required");
    });

    $('body').on('click', '[href="#new-client"]', function(event) {
        event.preventDefault();
        $('#is-client .family-container .family-inputs [name="familyname[]"]').prop('required',false);
        $('#is-client .family-container .family-inputs [name="birthdate[]"]').prop('required',false);
        $('#new-client .family-container .family-inputs [name="familyname[]"]').attr('required',"required");
        $('#new-client .family-container .family-inputs [name="birthdate[]"]').attr('required',"required");
    });

    $('body').on('click', '.remove-family-member', function(event) {
        event.preventDefault();
        $(this).parents('.family-inputs').remove();
    });

    $('body').on('submit', '#cart-payment-form', function (event) {
        event.preventDefault();
        var $this = $(this);

        grecaptcha.ready(function() {
            grecaptcha.execute(recaptchaSiteKey, {action: 'homepage'}).then(function(recaptchaResponseToken) {

                $($this).find("input[name='g-recaptcha-response']").remove();
                $this.prepend("<input name='g-recaptcha-response' type='hidden' value='"+recaptchaResponseToken+"' />");
                $($this).removeAttr('id');
                $this.submit();

            });
        });
    });

    $('body').on('submit', '.fop-ajax-form', function (event) {
        event.preventDefault();
        var $this = $(this);

        grecaptcha.ready(function() {
            grecaptcha.execute(recaptchaSiteKey, {action: 'homepage'}).then(function(recaptchaResponseToken) {
                // START logic to submit to backend here.

                $this.find('.fop-error-container').each(function () {
                    $this.removeClass('fop-error-container');
                    $this.find('.fop-error-right').remove();
                });
                var $button = $this.find('[type=submit]').last();
                $.ajax({
                    type: "POST",
                    url: $this.attr('action'),
                    cache: false,
                    data: $this.serialize() + '&g-recaptcha-response=' + recaptchaResponseToken, // Form serialized data + reCAPTCHA token
                    dataType: 'json',
                    beforeSend: function() {
                        $button.hide();
                        $button.after('<div class="cssload-square"> <div class="cssload-square-part cssload-square-green"></div> <div class="cssload-square-part cssload-square-pink"></div> <div class="cssload-square-blend"></div> </div>');
                    },
                    success: function (data) {

                        if (data.status == 0) {
                            $this.fadeOut().slideUp(1000, function () {
                                if (data.action == "message") {
                                    $("#success-msg").remove();
                                    $this.before("<div class='alert alert-success success animated bounceInLeft' id='success'><i class='fa fa-check'></i> " + data.message + "</div>");
                                    //$("<div class="alert alert-success success" id="success"><i class="fa fa-check"></i> Tu mensaje ha sido enviado correctamente.</div>").appendTo($this).addClass('animated bounceInRight');
                                } else if (data.action == "redirect") {
                                    document.location.href = data.redirect;
                                }
                            });
                        } else {
                            if(data.status == 2) {
                                //$('.recaptcha').before("<span class='fop-error-right'>" + data.message + "</span>").parent().addClass('fop-error-container');
                            } else {
                                if (typeof(data.generic_error) != 'undefined') {
                                    $("#success-msg").remove();
                                    $this.before("<p id='success-msg' class='alert alert-danger'>" + data.generic_error + "</p>");
                                    $([document.documentElement, document.body]).animate({
                                        scrollTop: $('.alert-danger').first().offset().top - 100
                                    }, 1000);
                                } else {
                                    for (var i = 0, len = data.errors.length; i < len; i++) {
                                        $('[name=' + data.errors[i].field + ']').before("<span class='fop-error-right'>" + data.errors[i].message + "</span>");
                                        $('[name=' + data.errors[i].field + ']').parent().addClass('fop-error-container');
                                    }
                                    $([document.documentElement, document.body]).animate({
                                        scrollTop: $('.fop-error-container').first().offset().top - 100
                                    }, 1000);
                                }
                            }
                        }

                    },
                    complete: function() {
                        $('.cssload-square').remove();
                        $button.show();
                    }
                });

                return false; // Submit finished

                // END logic to submit to backend here.
            });
        });
    });

    $('body').on('change', '#pharmacyOpenFilter', function(event) {
        if ($(this).val() == 0)
        {
            var url = $('#frmPharmacyOpenFilter').attr('action') + '/' + $('input[name=month]').val() + '/' + $('input[name=year]').val();
        } else {
            var url = $('#frmPharmacyOpenFilter').attr('action') + '/' + $(this).val() + '/' + $('input[name=month]').val() + '/' + $('input[name=year]').val();
        }
        document.location.href = url;
    });

    $('body').on('click', '.iframe-maps-wrapper', function(event) {
        $('.iframe-maps-wrapper iframe').removeClass('scrolloff');
    });

    $('body').on('mouseenter', '.fop-tooltip', function () {
        var title = $(this).attr('title');
        $(this).data('tipText', title).removeAttr('title');
        $('<p class="fop-tooltip-content"></p>')
            .text(title)
            .appendTo('body')
            .fadeIn(200);
    });
    $('body').on('mouseleave', '.fop-tooltip', function () {
        $(this).attr('title', $(this).data('tipText'));
        $('.fop-tooltip-content').remove();
    });
    $('body').on('mousemove', '.fop-tooltip', function (event) {
        var mousex = event.pageX + 20; //Get X coordinates
        var mousey = event.pageY + 10; //Get Y coordinates
        $('.fop-tooltip-content').css({top: mousey, left: mousex});
    });
    $('body').on('click', '.fop-tooltip', function (event) {
        $('.fop-tooltip-content').remove();
    });
    $('body').on('closed', '.fop-modal-maps', function () {
        $('div.fop-modal-maps').remodal().destroy();
        $('.fop-modal-maps').remove();
    });
    $('body').on('click', '.tooltip-maps td.color, .tooltip-maps td span', function (event) {
        event.preventDefault();
        $.ajax({
            url: $(this).data('url'),
            dataType: 'json',
            success: function(data) {
                //$('<p class="fop-modal-maps remodal"></p>').html(data.html).appendTo('body');
                $('<div class="fop-modal-maps"></div>').appendTo('body').html(data.html);
                $('div.fop-modal-maps').remodal().open();
                var latlng = new google.maps.LatLng(data.latitude, data.longitude);
                console.log("Latitude: " + data.latitude + " - Longitude: " + data.longitude);
                var myOptions = {
                    zoom: 15,
                    center:latlng,
                    draggable: true
                };
                var map = new google.maps.Map(document.getElementById("pharmacy-map"),myOptions);
                var marker = new google.maps.Marker({
                    position: latlng,
                    map: map
                });
                map.setCenter(latlng);
                console.log(map);
            },
            complete: function() {

            }
        });

    });

    //new open modal maps for new_pharmacy_open blade
    $('body').on('click', '.tooltip-maps-li, .tooltip-maps span', function (event) {
        event.preventDefault();
        $.ajax({
            url: $(this).data('url'),
            dataType: 'json',
            success: function(data) {
                //$('<p class="fop-modal-maps remodal"></p>').html(data.html).appendTo('body');
                $('<div class="fop-modal-maps"></div>').appendTo('body').html(data.html);
                $('div.fop-modal-maps').remodal().open();
                var latlng = new google.maps.LatLng(data.latitude, data.longitude);
                var myOptions = {
                    zoom: 15,
                    center:latlng,
                    draggable: true
                };
                var map = new google.maps.Map(document.getElementById("pharmacy-map"),myOptions);
                var marker = new google.maps.Marker({
                    position: latlng,
                    map: map
                });
                map.setCenter(latlng);
            },
        complete: function() {
            }
        });
    });

    $('body').on("click", ".goto-href", function (e) {
        document.location.href = $(this).data('href');
    });

    $('body').on('submit', '#reset-password-form', function (event) {
        event.preventDefault();
        $.ajax({
            url: $(this).attr('action'),
            type: 'post',
            dataType: 'json',
            cache: false,
            data: $(this).serialize(),
            success: function (data) {
                console.log(data);
                if(data.status == 0) {
                    $('#content-result').html("<div class='alert alert-success'>" + data.message + "</div>");
                } else if(data.status == 1) {
                    alert("session");
                    $('#content-result').html("<div class='alert alert-warning'>" + data.message + "</div>");
                } else if(data.status == 2) {
                    $('#content-result').prepend("<div class='alert alert-warning'>" + data.message + "</div>");
                }
            }
        });
        return false;
    });

    $('body').on('submit', '#reset-form', function (event) {
        event.preventDefault();
        $.ajax({
            url: $(this).attr('action'),
            type: 'post',
            data: $(this).serialize(),
            dataType: 'json',
            success: function (data) {
                if(data.status=='0') {
                    $('#content-result').html("<div class='alert alert-success'><p>" + data.message + "</p></div>");
                } else if(data.status=='1') {
                    $('#content-result').prepend("<div class='alert alert-warning'><p>" + data.message + "</p></div>");
                }
            }
        });
        return false;
    });

    $('body').on('change', '.extrainfo-select', function(event) {
        var id = $(this).data('id');
        var placeholder = $(this).find('option:selected').data('placeholder');
        if($(this).find('option:selected').data('openfield')) {
            $('#extrainfo-open-field-' + id).find('input').attr('placeholder', placeholder);
            $('#extrainfo-open-field-' + id).removeClass('dnone').addClass('animated bounceInLeft');
        } else if($('#extrainfo-open-field-' + id).hasClass('bounceInLeft')) {
            $('#extrainfo-open-field-' + id).removeClass('animated bounceInLeft').addClass('animated bounceOutLeft').one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function() {
                $('#extrainfo-open-field-' + id).addClass('dnone');
            });


        }
    });

    $('body').on('submit', '#form-extrainfo', function(event) {
        var $button = $(this).find('[type=submit]').last();
        var $form = $(this);
        $.ajax({
            url: $form.attr('action'),
            data: $form.serialize(),
            type: 'post',
            beforeSend: function() {
                $button.hide();
                $button.after('<div class="cssload-square"> <div class="cssload-square-part cssload-square-green"></div> <div class="cssload-square-part cssload-square-pink"></div> <div class="cssload-square-blend"></div> </div>');
            },
            success: function(data) {
                $form.hide();
                $form.before("<div class='alert alert-success success animated bounceInLeft' id='success'><i class='fa fa-check'></i> " + data + "</div>");
            }
        });
        return false;
    });

    $('body').on('mouseenter', '.fo-tooltip', function () {
        var title = $(this).attr('title');
        $(this).data('tipText', title).removeAttr('title');
        $('<p class="fo-tooltip-content"></p>')
            .text(title)
            .appendTo('body')
            .fadeIn(200);
    });
    $('body').on('mouseleave', '.fo-tooltip', function () {
        $(this).attr('title', $(this).data('tipText'));
        $('.fo-tooltip-content').remove();
    });
    $('body').on('mousemove', '.fo-tooltip', function (event) {
        if($(this).hasClass('fo-tooltip-right')) {
            var mousex = event.pageX - 115; //Get X coordinates
        } else {
            var mousex = event.pageX + 20; //Get X coordinates
        }
        var mousey = event.pageY + 10; //Get Y coordinates
        $('.fo-tooltip-content').css({top: mousey, left: mousex});
    });
    $('body').on('click', '.fo-tooltip', function (event) {
        $('.fo-tooltip-content').remove();
    });

    $('body').on('click', '#fop-calendar .pharmacy', function(event) {
        $('#fop-calendar-legend td[data-id=' + $(this).data('id') + ']').trigger('click');
    });

    $('body').on('click', '.img-layette', function () {
        $(this).parent().find('.layette-content h3 a').trigger('click');
    });

    $('body').on('click', '.layette-content p', function () {
        $(this).parent().find('h3 a').trigger('click');
    });


    $(document).ajaxStart(function(){

        $('.overlap-ajax').fadeIn(300);

    });


    $(document).ajaxStop(function(){

        $('.overlap-ajax').fadeOut(300);
        $('.overlap.ajax .sk-text').text('');

    });

    //get client data if user_import->nif exists on keyUp
    $(".client_form .NifgetClientInfo").keyup(function (e) {

        //get nif value entered on "soc client tab"
        var nif = $(".client_form .NifgetClientInfo").val();

        //get parent form
        var form = $(".NifgetClientInfo").closest('.client_form');

        if(nif.length>=9){
            $.ajax({
                type: "POST",
                url: $(".NifgetClientInfo").data('url'),
                dataType: "json",
                data: form.serialize(),
                success: function (data) {
                    if (data.status == 0) {
                        if (data.action == "message") {

                            $("#success-msg").remove();

                            form.before("<div class='alert alert-success success animated bounceInLeft' id='success-msg'><i class='fa fa-check'></i> " + data.message + "</div>");

                            //esborrar dades previes del form
                            $('.fop-ajax-form').find("input[type=text], input[type=email], input[type=tel], textarea").val("");
                            //esborrar checkbox marcats
                            $('.fop-ajax-form').closest('.client_form').find("input[type=checkbox]").prop('checked', false);


                            //get options field(checkbox interessos)
                            for (var i = 0; i < data.options.length; i++) {
                                //marcar interessos rebuts per options
                                form.find('#' + +data.options[i]).prop('checked', true);
                            }

                            //per cada key rebuda del json que conte les dades del client, omplim
                            Object.keys(data.user_import).forEach(function(k){
                                if ($('input[name="'+k+'"]').length > 0) {
                                    form.find(('input[name="'+k+'"]')).val(data.user_import[k]); //omplir els inputs que tenen el mateix nom que la key rebuda
                                }
                                //cas select option value es tracta diferent
                                if(k=='gender') {
                                    form.find(('select[name="'+k+'"]')).val(data.user_import[k]);
                                }
                            });

                            //get family
                            /*for (var i = 0; i < data.family.length; i++) {
                                console.log(data.family[i]);

                                var findClass = '';
                                if ($('#is-client').hasClass('active')) {
                                    findClass = '#is-client';
                                } else {
                                    findClass = '#new-client';
                                }

                                var dates = {};
                                if($('#babies').length) {
                                    dates = {'maxDate': 0}
                                }

                                if($('#pregnancy').length) {
                                    dates = {'minDate':0}
                                }

                                if(i==0) {
                                    $('.family-original').first().clone().removeClass('family-original').removeClass('dnone').appendTo(findClass + ' .family-container').find('.birthdate').myDatePicker(dates);
                                }

                                $(findClass+' .family-container .family-inputs [name="familyname[]"]').attr('required',"required");
                                $(findClass+' .family-container .family-inputs [name="birthdate[]"]').attr('required',"required");

                            }*/

                        }
                    }else{
                        if (typeof(data.generic_error) != 'undefined') {
                            //esborrar dades previes del form
                            $('.NifgetClientInfo').closest('form').find("input[type=text], input[type=email], input[type=tel], textarea, select").val("");
                            //esborrar checkbox marcats
                            $(".NifgetClientInfo").closest('.client_form').find("input[type=checkbox]").prop('checked', false);

                            $("#success-msg").remove();
                            form.before("<p id='success-msg' class='alert alert-danger'>" + data.generic_error + "</p>");
                        } else {
                            //esborrar dades previes del form
                            $('.NifgetClientInfo').closest('form').find("input[type=text], textarea, select").val("");
                            //esborrar checkbox marcats
                            $(".NifgetClientInfo").closest('.client_form').find("input[type=checkbox]").prop('checked', false);

                            for (var i = 0, len = data.errors.length; i < len; i++) {
                                if ($('[name=' + data.errors[i].field + ']').attr('type') == 'radio') {
                                    $('input:radio').parent().parent().before("<span class='fop-error-right'>" + data.errors[i].message + "</span>");
                                    $('input:radio').parent().parent().parent().addClass('fop-error-container');
                                } else {
                                    $('[name=' + data.errors[i].field + ']').before("<span class='fop-error-right'>" + data.errors[i].message + "</span>");
                                    $('[name=' + data.errors[i].field + ']').parent().addClass('fop-error-container');
                                }

                            }
                        }
                    }
                },
                error: function (message) {
                    console.log('Error: ' + message);
                    response('Error: ' + message);
                }
            });

        }else{

            //esborrar dades previes del form excepte la del nifnie
            $('.fop-ajax-form').find("input[type=text][name!=nifnie], input[type=email], input[type=tel], textarea, select").val("");
            //esborrar checkbox marcats
            $('.fop-ajax-form').closest('.client_form').find("input[type=checkbox]").prop('checked', false);

        }
    });

    /** Ecommerce aside sticky start height fix **/
    $(window).on("resize scroll", function() {
        var initialHeight = 0;

        if ($("header.fixed").length) {
            initialHeight = $("header").first().outerHeight();
        }

        $(".ecommerce-aside").css("top", initialHeight + "px");
        $(".ecommerce-aside").css("height", "calc(100vh - " + initialHeight + "px)");
    });

    $(window).trigger("resize");
});

$.fn.myDatePicker = function(extraParams){


    $.datepicker.regional['es'] = {
        closeText: 'Cerrar',
        prevText: '&#x3C;Ant',
        nextText: 'Sig&#x3E;',
        currentText: 'Hoy',
        monthNames: ['Enero','Febrero','Marzo','Abril','Mayo','Junio',
            'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
        monthNamesShort: ['Ene','Feb','Mar','Abr','May','Jun',
            'Jul','Ago','Sep','Oct','Nov','Dic'],
        dayNames: ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'],
        dayNamesShort: ['Dom','Lun','Mar','Mié','Juv','Vie','Sáb'],
        dayNamesMin: ['Do','Lu','Ma','Mi','Ju','Vi','Sa'],
        weekHeader: 'Sm',
        dateFormat: 'dd/mm/yy',
        firstDay: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ''};

    $.datepicker.setDefaults($.datepicker.regional['es']);
    $.datepicker.setDefaults(extraParams);

    var mydate = this;

    mydate.datepicker({
        dateFormat: 'dd/mm/yy',
        changeMonth: true,
        changeYear: true,
        yearRange: "-80:+10",
    }).mask("00/00/0000",{
        // placeholder:"MM/DD/YYYY",
        // clearIfNotMatch: true,
        onComplete:function(){
            if( !checkDate(mydate.val()) ){
                mydate.val('');
            }
        }
    });

    mydate.focusout(function() {
        if( !checkDate(mydate.val()) ){
            mydate.val('');
        }
    });

    return this;
};

function checkDate(val){
    var er = /^(((0[1-9]|[12][0-9]|3[01])([-.\/])(0[13578]|10|12)([-.\/])(\d{4}))|(([0][1-9]|[12][0-9]|30)([-.\/])(0[469]|11)([-.\/])(\d{4}))|((0[1-9]|1[0-9]|2[0-8])([-.\/])(02)([-.\/])(\d{4}))|((29)(\.|-|\/)(02)([-.\/])([02468][048]00))|((29)([-.\/])(02)([-.\/])([13579][26]00))|((29)([-.\/])(02)([-.\/])([0-9][0-9][0][48]))|((29)([-.\/])(02)([-.\/])([0-9][0-9][2468][048]))|((29)([-.\/])(02)([-.\/])([0-9][0-9][13579][26])))$/;

    if (!er.test(val))
        return false;
    else
        return true;
}


function PopupCenter(url, title, w, h) {
    // Fixes dual-screen position                         Most browsers      Firefox
    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;
    var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (window.focus) {
        newWindow.focus();
    }
}

function GetReCaptchaID(containerID) {
    var retval = -1;
    $(".g-recaptcha").each(function(index) {
        if(this.id == containerID)
        {
            retval = index;
            return;
        }
    });

    return retval;
}

function recaptchaReset(data) {
    if (!data.hasOwnProperty('no-recaptcha')) {
        if( $('.recaptcha').length > 1) {
            //Cal que els recaptchas tinguin un id únic
            $('.recaptcha').each(function( index ) {
                var reCaptchaID = GetReCaptchaID($(this).attr('id'));
                grecaptcha.reset(reCaptchaID);
            });
        } else if (data.v3 !== undefined && data.v3 !== null) {
            grecaptcha.execute(data.v3).
            then(function(token) {
                document.querySelector('#recaptchaResponse').value = token;
            });
        } else {
            grecaptcha.reset();
        }
    }
}

function getCookie(c_name) {
    var i, x, y, ARRcookies = document.cookie.split(";");
    for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
        y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x === c_name) {
            return unescape(y);
        }
    }
}

function deleteCookie(c_name) {

    //domini check
    var domain = window.location.hostname;

    if(domain.includes('canalfarmaciaonline')){ //subdomini
        //mirem si tenim cookies a alguns dels dominis(cfo/go i borrem)
        document.cookie = c_name + '=; Path=/; Domain=.farmaoffice.test; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = c_name + '=; Path=/; Domain=.canalfarmaciaonline.com; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        document.cookie = c_name + '=; Path=/; Domain=.farmaofficego.com; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';

    }else{ //domini propi
        document.cookie = c_name + '=; Path=/; Domain=.'+domain+'; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

}

function clearCookies() {

    var cookies = document.cookie.split(";");

    for(var i=0; i < cookies.length; i++) {
        var equals = cookies[i].indexOf("=");
        var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i];

        if (name !== "laravel_session" && name !== "cookie-consent") { //until not accepted cookie consent, delete all cookies except this
            deleteCookie(name);
        }

    }
}
